<template>
  <b-autocomplete
    v-model="name"
    :data="data"
    icon="magnify"
    placeholder="Select magazine"
    field="name"
    :loading="isFetching"
    @input="getAsyncData"
    @select="option => { selected = option }"
    open-on-focus
    expanded
  >
    <template slot-scope="{ option: magazine }">
      <div class="media">
        <div class="media-content">
          <strong>{{ magazine.id }}</strong>
          <div class="has-text-grey">{{ magazine.name }}</div>
        </div>
      </div>
    </template>
  </b-autocomplete>
</template>

<script>
import debounce from "lodash/debounce";

export default {
  props: {
    type: String,

    url: {
      type: String,
      default: "/admin/api/magazine/magazines?include=plans"
    }
  },

  data() {
    return {
      data: [],
      name: "",
      selected: null,
      isFetching: false
    };
  },

  created() {
    this.getAsyncData();
  },

  watch: {
    selected(magazine) {
      this.$emit("input", magazine ? magazine.id : null);

      this.$emit("change", magazine);
    }
  },

  methods: {
    clear() {
      this.name = "";
      this.selected = null;
    },

    getAsyncData: debounce(function() {
      this.data = [];
      this.isFetching = true;
      this.$http
        .get(this.url, {
          params: {
            search: this.name,
            "filter[type]": this.type
          }
        })
        .then(({ data }) => {
          data.data.forEach(item => this.data.push(item));
          this.isFetching = false;
        })
        .catch(error => {
          this.isFetching = false;
          throw error;
        });
    }, 300)
  }
};
</script>
